import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Menu, MenuItem, Pagination, Stack, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, useTheme } from "@mui/material"
import { CAP, CashFlowClassification, CashFlowMapping, GeneralTrialBalance, GTBClassification, GTBRecords, GTBRequest, SocialAccountMapping } from "../../helpers/interfaces";
import { useCallback, useEffect, useState } from "react";
import { getAllCAP, getAllCashFlowClassification, getAllCashFlowMappings, getAllGTBClassification, getAllSocialAccountMapping } from "../../apiServices/GTBMappingKeysApi";
import { exportAllMappedGTB, exportAllUnmappedGTB, exportMappedGTB, exportUnmappedGTB, getGTBRecords, UpdateGTBRecords, uploadGBTRecordsExcelFile } from "../../apiServices/GTBRecordsApi";
import saveAs from "file-saver";
import { CustomTextField, } from "../../layouts/themes";
import { Download, Save, Upload } from "@mui/icons-material";
import { BSPL, isMapped } from "../../helpers/constants";
import styled from "@emotion/styled";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import React from "react";

import { formatShortDateString, showAlertMessage } from "../../helpers/utils";

const bsplOptions = [{ value: BSPL.BS, label: 'BS' }, { value: BSPL.PL, label: 'PL' }]

interface Props {
    year: number
    setYear: React.Dispatch<React.SetStateAction<number>>
    mappingStatus: isMapped
    setSelectedTabValue: React.Dispatch<React.SetStateAction<number>>
    selectedTabValue: number
}
function GtBalanceRecords({ setYear, year, mappingStatus, setSelectedTabValue, selectedTabValue }: Props) {

    const theme = useTheme();
    const [generalBlanceRecords, setGeneralTrialBlanceRecords] = useState<GTBRecords[]>([])
    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    //const [filteredGeneralrialBlanceRecords, setFilteredGeneralTrialBlanceRecords] = useState<GTBRecords[]>([])
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [recordsPerPage, setRecordsPerPage] = useState<number>(20);
    const [numOfPages, setNumOfPages] = useState<number>(0);
    const [currentPageRecords, setCurrentPageRecords] = useState<GTBRecords[]>([])

    const [gtbDataRequest, setGTBDataRequest] = useState<GTBRecords[]>([])

    const [socialAccountMappingOptions, setSocialAccountMappingOptions] = useState<SocialAccountMapping[]>([])
    const [cashFlowClassificationOptions, setCashFlowClassificationOptions] = useState<CashFlowClassification[]>([])
    const [cashFlowMappingOptions, setCashFlowMappingOptions] = useState<CashFlowMapping[]>([])
    const [gtbClassificationOptions, setGtbClassificationOptions] = useState<GTBClassification[]>([])
    const [capOptions, setCapOptions] = useState<CAP[]>([])
    const [changeYear, setChangeYear] = useState(false)
    const [changedYear, setChangedYear] = useState(0)
    const [isUploading, setIsUploading] = useState(false);

    const [selectedMonth, setSelectedMonth] = useState<string>("All");
    const getGTB = useCallback(async () => {
        let data: GeneralTrialBalance = await getGTBRecords(mappingStatus, recordsPerPage, currentPage, year)

        setGeneralTrialBlanceRecords(data.data)
        setCurrentPage(data.pageIndex)
        setNumOfPages(data.totalPages)
        setRecordsPerPage(data.pageSize)
        setCurrentPageRecords(data.data)
    }, [mappingStatus, recordsPerPage, currentPage, year]);

    useEffect(() => {
        getGTB();
    }, [getGTB]);
    useEffect(() => {
        getAllCashFlowClassification().then(cfc => setCashFlowClassificationOptions(cfc))
        getAllCashFlowMappings().then(cfm => setCashFlowMappingOptions(cfm))
        getAllGTBClassification().then(gtb => setGtbClassificationOptions(gtb))
        getAllSocialAccountMapping().then(sam => setSocialAccountMappingOptions(sam))
        getAllCAP().then(cap => setCapOptions(cap))


    }, [])

    /*   useEffect(() => {
          setFilteredGeneralTrialBlanceRecords(generalBlanceRecords.filter(e =>
              (searchQuery === "" || e.description.toLowerCase().includes(searchQuery.toLowerCase()) || e.glAccount.toLowerCase().includes(searchQuery.toLowerCase()))
          ));
          setCurrentPage(1);
      }, [searchQuery, generalBlanceRecords])
  
  
      useEffect(() => {
          setNumOfPages(Math.ceil(filteredGeneralrialBlanceRecords.length / recordsPerPage))
      }, [recordsPerPage, filteredGeneralrialBlanceRecords])
  
      useEffect(() => {
          const lastIndex = currentPage * recordsPerPage;
          const firstIndex = lastIndex - recordsPerPage;
          setCurrentPageRecords(filteredGeneralrialBlanceRecords.slice(firstIndex, lastIndex))
      }, [currentPage, recordsPerPage, filteredGeneralrialBlanceRecords])
   */
    // Handle CAP code selection change
    const handleSelectChange = (id: string, index: any, selectedID: string) => {
        const selectedCapDesc = capOptions.find((cap) => cap.id === selectedID);

        const initialRow = [...currentPageRecords];
        const selectedRoow = initialRow[index]
        initialRow[index] = selectedCapDesc ? {
            ...selectedRoow,
            capId: selectedID,
            cap: selectedCapDesc,
        } : selectedRoow;

        setCurrentPageRecords(initialRow);
        updateFieldValue(id, 'capId', selectedID)
    };

    /*  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
         e.persist(); //important to persist event so we can reset the value of the input file after an upload
         if (e.target.files == null || e.target.files.length === 0) return
         const formData = new FormData()
         formData.append('MappedFile', e.target.files[0])
         uploadGBTRecordsExcelFile(formData)
         e.target.value = '' //important to persist event so we can reset the value of the input file after an upload
     } */

   

    const updateFieldValue = (id: string, fieldName: string, newValue: any) => {

        const updatedRecords = generalBlanceRecords.map(rec =>

            rec.id === id ? { ...rec, [fieldName]: newValue } : rec

        );

        setGeneralTrialBlanceRecords(updatedRecords);

        // ✅ Also update currentPageRecords so UI reflects changes

        const updatedPageRecords = currentPageRecords.map(rec =>

            rec.id === id ? { ...rec, [fieldName]: newValue } : rec

        );

        setCurrentPageRecords(updatedPageRecords);

        // ✅ Track changes for mapping

        const record = updatedRecords.find(r => r.id === id)!;

        setGTBDataRequest(prev => {

            const existing = prev.find(e => e.id === id);

            if (existing) {

                return prev.map(e => (e.id === id ? record : e));

            }

            return [...prev, record];

        });

    };
    function mapGTBRecords() {
        const gbtRequest: GTBRequest[] = gtbDataRequest.map(item => ({
            generalTrialBalanceId: item.id,
            socialAccountMappingId: item.socialAccountMappingId,
            capId: item.capId,
            bspl: item.bspl,
            cashODMapping: item.cashODMapping,
            classificationId: item.classificationId,
            cashFlowClassificationId: item.cashFlowClassificationId,
            cashFlowMappingId: item.cashFlowMappingId
        }));
        UpdateGTBRecords(gbtRequest).then(_gtb => {

            //props.setGeneralTrialBlanceRecords(gtb => [...gtb, _gtb])

        })


        setSelectedTabValue(3)

    }
    const filteredRecords = currentPageRecords.filter((record) => {

        const costObjectMatch =

            record.glAccount?.toLowerCase().includes(searchQuery.toLowerCase())



        if (selectedMonth === "All") return costObjectMatch;

        const recordMonth = new Date(record.createdAt).toLocaleString("default", {

            month: "long",

        });

        return costObjectMatch && recordMonth === selectedMonth;

    });

    function handleAllUnmappedGTBExport() {
        exportAllUnmappedGTB(year).then(async (base64string) => {
            const blob = base64ToBlob(base64string, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            saveAs(blob, `GTB_PPT_${year}_Unmapped.xlsx`);
        })
    }
    function handleUnmappedGTBExport() {
        exportUnmappedGTB(recordsPerPage, year).then(async (base64string) => {
            const blob = base64ToBlob(base64string, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            saveAs(blob, `GTB_PPT_${year}_Unmapped.xlsx`);
        })
    }

    function exportAllMappedGTBData() {
        exportAllMappedGTB(year).then(async (base64string) => {
            const blob = base64ToBlob(base64string, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            saveAs(blob, `GTB_PPT_${year}_Mapped.xlsx`);
        })
    }

    function exportMappedGTBData() {
        exportMappedGTB(recordsPerPage, year).then(async (base64string) => {
            const blob = base64ToBlob(base64string, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            saveAs(blob, `GTB_PPT_${year}_Mapped.xlsx`);
        })
    }

    function base64ToBlob(base64string: string, type: string) {
        const binaryString = window.atob(base64string);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return new Blob([bytes], { type: type });
    }
    const StyledTableRow = styled(TableRow)({
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover,
            size: 'small',
        },
        border: '1px solid #cbcbcb !important',


    });
    const StyledTableCell = styled(TableCell)({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.action.hover : theme.palette.action.hover,
            color: theme.palette.error.main,
            fontSize: 11,
            size: 'small',
            fontWeight: 550,
            border: '1px solid #cbcbcb !important',



        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 11,
            size: 'small',
            padding: 7,
            border: '1px solid #cbcbcb !important',



        },
    });
    const handleClosePopupState = (popupState: { close: () => void }) => {
        popupState.close();
    };
    return (
        <>
            <div className=" flex flex-row ">
                <div className="flex gap-2 w-1/2">
                    {/* Search */}
                    <CustomTextField
                        size="small"
                        placeholder="Search by Cost Object..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        variant="outlined"
                        sx={{ flex: 1 }}
                    />

                    {/* Month Filter */}
                    <CustomTextField
                        select
                        size="small"
                        label="Filter By Month"
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        sx={{ width: 180 }}
                    >
                        <MenuItem value="All">All Months</MenuItem>
                        {[
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December",
                        ].map((month) => (
                            <MenuItem key={month} value={month}>
                                {month}
                            </MenuItem>
                        ))}
                    </CustomTextField>
                </div>
                <div style={{ flexGrow: 1 }} />

                {selectedTabValue === 3 &&
                    <>
                        <Button
                            color="success"
                            variant="outlined"
                            onClick={() => setImportDialogOpen(true)}
                        >
                            <Upload /> &nbsp;&nbsp;Import GTB
                        </Button>
                        &nbsp;&nbsp;

                        <PopupState variant="popover" popupId="demo-popup-menu">
                            {(popupState) => (
                                <React.Fragment>
                                    <Button color='success' variant="outlined" size="small" {...bindTrigger(popupState)} disabled={generalBlanceRecords.length === 0}><img style={{ width: '20px' }} src='../../assets/images/icons8-excel.svg' alt="export Mapped GTB Data" />&nbsp;<b>Export</b> </Button>
                                    <Menu {...bindMenu(popupState)}>
                                        <MenuItem onClick={() => { exportAllMappedGTBData(); handleClosePopupState(popupState); }}> <Download color='secondary' /> &nbsp;&nbsp; Export All Mapped GTB Records</MenuItem>
                                        <Divider />
                                        <MenuItem onClick={() => { exportMappedGTBData(); handleClosePopupState(popupState) }}> <Download color='secondary' /> &nbsp;&nbsp; Export Mapped GTB Records</MenuItem>

                                    </Menu>
                                </React.Fragment>
                            )}
                        </PopupState>&nbsp;&nbsp;

                    </>
                }

                {selectedTabValue === 2 &&
                    <>

                        <PopupState variant="popover" popupId="demo-popup-menu">
                            {(popupState) => (
                                <React.Fragment>
                                    <Button color='success' variant="outlined" size="small" {...bindTrigger(popupState)} disabled={generalBlanceRecords.length === 0}><img style={{ width: '20px' }} src='../../assets/images/icons8-excel.svg' alt="export Mapped GTB Data" />&nbsp;<b>Export</b> </Button>
                                    <Menu {...bindMenu(popupState)}>
                                        <MenuItem onClick={() => { handleAllUnmappedGTBExport(); handleClosePopupState(popupState); }}> <Download color='secondary' /> &nbsp;&nbsp; Export All Unmapped GTB Records</MenuItem>
                                        <Divider />
                                        <MenuItem onClick={() => { handleUnmappedGTBExport(); handleClosePopupState(popupState) }}> <Download color='secondary' /> &nbsp;&nbsp; Export Current Page GTB Records</MenuItem>

                                    </Menu>
                                </React.Fragment>
                            )}
                        </PopupState>&nbsp;&nbsp;
                    </>
                }

                <Button color='info' size="small" variant="contained" onClick={mapGTBRecords} disabled={generalBlanceRecords.length === 0} > <Save sx={{ width: '20px' }} /> &nbsp;Save </Button>
            </div>
            <br />
            <>
                <div className="">
                    <TableContainer className="table table-bordered table-sm table-responsive" sx={{ maxHeight: '56vh', overflowX: 'scroll', overflowY: 'auto', border: '1px solid rgba(224, 224, 224, 1)', '&::-webkit-scrollbar': { width: '6px', height: '6px', }, '&::-webkit-scrollbar-track': { backgroundColor: 'rgba(0,0,0,0.1)', }, '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.3)', borderRadius: '4px', }, '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(0,0,0,0.5)', } }}    >
                        <Table size="small" aria-label="a dense table" aria-labelledby="tableTitle">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell style={{ position: "sticky", left: 0, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }}> SN</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '100px', position: "sticky", left: 100, zIndex: 1, background: `${theme.palette.error.contrastText}`, }}> Co.Code</StyledTableCell>
                                    <StyledTableCell style={{ position: "sticky", left: 200, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }}>Business Area</StyledTableCell>
                                    <StyledTableCell style={{ position: "sticky", left: 300, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }}>GL Account</StyledTableCell>
                                    <StyledTableCell style={{ position: "sticky", left: 400, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }}>Description</StyledTableCell>
                                    <StyledTableCell style={{ position: "sticky", left: 500, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }}>Amount</StyledTableCell>



                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '100px' }}>Adjustment</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '100px' }}>Final TB</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '300px' }}>Social Account Mapping</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '300px' }}>CAP Description</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '300px' }}>CAP Code </StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '300px' }}>BS/PL</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '300px' }}>Classification</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '30px' }}>Cash/OD Mapping</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '300px' }}>Cash Flow Classification</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '300px' }}>Cash Flow  Mapping</StyledTableCell>

                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '100px' }}>Fetched At</StyledTableCell>
                                    <StyledTableCell style={{ fontSize: '12px', minWidth: '100px' }}>Last Updated</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {filteredRecords.map((item, index) => {
                                    return <StyledTableRow key={index}>

                                        <StyledTableCell style={{ position: "sticky", left: 0, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }}>
                                            {index + 1 + ((currentPage - 1) * recordsPerPage)}
                                        </StyledTableCell>
                                        <StyledTableCell style={{ fontSize: '12px', minWidth: '100px', position: "sticky", left: 100, zIndex: 1, background: `${theme.palette.error.contrastText}`, }}  >{item.coCode}</StyledTableCell>
                                        <StyledTableCell style={{ position: "sticky", left: 200, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }} >{item.busArea}</StyledTableCell>
                                        <StyledTableCell style={{ position: "sticky", left: 300, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }}  >{item.glAccount}</StyledTableCell>
                                        <StyledTableCell style={{ position: "sticky", left: 400, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }} >{item.description}</StyledTableCell>

                                        <StyledTableCell style={{ position: "sticky", left: 500, zIndex: 1, background: `${theme.palette.error.contrastText}`, fontSize: '12px', minWidth: '100px' }} >{item.amount}</StyledTableCell>

                                        <StyledTableCell  >{item.adjustment}</StyledTableCell>
                                        <StyledTableCell  >{item.finalTB}</StyledTableCell>

                                        <StyledTableCell >
                                            <CustomTextField fullWidth size="small" select variant="outlined" id="socialAccountMappingId" value={item.socialAccountMappingId} onChange={(e) => updateFieldValue(item.id, 'socialAccountMappingId', e.target.value)} >
                                                {socialAccountMappingOptions.map((sam, index1) => {
                                                    return <MenuItem key={index1} value={sam.id}>{sam.name}</MenuItem >
                                                })}
                                            </CustomTextField>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <CustomTextField select fullWidth size="small" variant="outlined" value={item.capId} id="description" onChange={(e) => handleSelectChange(item.id, index, e.target.value)}>
                                                <MenuItem defaultValue="Select a CAP Description">Select a CAP Description</MenuItem>
                                                {capOptions.map((cap) => (
                                                    <MenuItem key={cap.code} value={cap.id}>
                                                        {cap.description}
                                                    </MenuItem>
                                                ))}
                                            </CustomTextField>
                                        </StyledTableCell>
                                        <StyledTableCell >
                                            <CustomTextField fullWidth size="small" variant="outlined" value={item.cap?.code} id="capCode" placeholder="CAP CODE">        </CustomTextField>
                                        </StyledTableCell>

                                        <StyledTableCell >
                                            <CustomTextField fullWidth size="small" select variant="outlined" id="bspl" value={item.bspl} onChange={(e) => updateFieldValue(item.id, 'bspl', e.target.value)} >
                                                {bsplOptions.map((bspl, index3) => {
                                                    return <MenuItem key={index3} value={bspl.value}>{bspl.label}</MenuItem >
                                                })}
                                            </CustomTextField>
                                        </StyledTableCell>
                                        <StyledTableCell >
                                            <CustomTextField fullWidth size="small" select variant="outlined" id="classificationId" value={item.classificationId} onChange={(e) => updateFieldValue(item.id, 'classificationId', e.target.value)}>
                                                {gtbClassificationOptions.map((gtb, index4) => {
                                                    return <MenuItem key={index4} value={gtb.id}>{gtb.name}</MenuItem >
                                                })}
                                            </CustomTextField>
                                        </StyledTableCell>
                                        <StyledTableCell >
                                            <div id="cashODMapping"><Checkbox color='secondary' value='true' checked={item.cashODMapping} onChange={(e) => updateFieldValue(item.id, 'cashODMapping', e.target.checked)} />&nbsp;Yes</div>
                                        </StyledTableCell>
                                        <StyledTableCell >
                                            <CustomTextField fullWidth size="small" select variant="outlined" id="cashFlowClassificationId" value={item.cashFlowClassificationId} onChange={(e) => updateFieldValue(item.id, 'cashFlowClassificationId', e.target.value)}  >
                                                {cashFlowClassificationOptions.map((cashflow, index6) => {
                                                    return <MenuItem key={index6} value={cashflow.id}>{cashflow.name}</MenuItem >
                                                })}
                                            </CustomTextField>
                                        </StyledTableCell>
                                        <StyledTableCell >
                                            <CustomTextField fullWidth size="small" select variant="outlined" id="CashFlowMapping" value={item.cashFlowMappingId} onChange={(e) => updateFieldValue(item.id, 'cashFlowMappingId', e.target.value)} >
                                                {cashFlowMappingOptions.map((cashMap, index7) => {
                                                    return <MenuItem key={index7} value={cashMap.id}>{cashMap.name}</MenuItem >
                                                })}
                                            </CustomTextField>
                                        </StyledTableCell>
                                        <StyledTableCell  >{formatShortDateString(item.createdAt, false)}</StyledTableCell>
                                        <StyledTableCell  >{formatShortDateString(item.updatedAt, false)}</StyledTableCell>

                                    </StyledTableRow>
                                })}

                                {filteredRecords.length === 0 &&
                                    <tr>
                                        <StyledTableCell colSpan={13}><p style={{ fontSize: '11px', textAlign: 'center' }}>No record available...</p></StyledTableCell>
                                    </tr>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <br />

                <nav>
                    <div className=" flex flex-row ">
                        <div className=" flex items-start ">
                            <div className="px-6 py-2">Rows per page</div>&nbsp;
                            < Grid item xs={12} lg={3} >
                                <CustomTextField fullWidth id="fullWidth" select variant="outlined" size="small" name="RequestsNumbers" value={recordsPerPage} onChange={(e) => setRecordsPerPage(Number(e.target.value))} >
                                    <MenuItem value="20">20</MenuItem >
                                    <MenuItem value="40">40</MenuItem >
                                    <MenuItem value="55">55</MenuItem >
                                    <MenuItem value="85">85</MenuItem >
                                    <MenuItem value="125">125</MenuItem >
                                    <MenuItem value="200">200</MenuItem >
                                    <MenuItem value="255">255</MenuItem >
                                    <MenuItem value="350">350</MenuItem >
                                    <MenuItem value="500">500</MenuItem >


                                </CustomTextField>
                            </Grid>
                        </div>
                        <div style={{ flexGrow: 1 }} />
                        <Stack spacing={2}>
                            <Pagination color="secondary" count={numOfPages} siblingCount={1} boundaryCount={1}
                                onChange={(event, value) => setCurrentPage(value)} page={currentPage} size="small" classes={{ ul: "PaginationUl" }} />
                        </Stack>

                    </div>
                    <br />


                </nav>
            </>
            <Dialog
                open={importDialogOpen}
                onClose={() => {
                    setImportDialogOpen(false);
                    setSelectedFile(null);
                }}
                fullWidth
                maxWidth="sm"
            >
                <div className="flex justify-between ">
                    <DialogTitle>Import GTB Records</DialogTitle>

                    <DialogActions style={{ width: '50%' }}>
                        <Button color="secondary" style={{ marginRight: 20 }} onClick={() => setImportDialogOpen(false)}>Close</Button>

                    </DialogActions>
                </div>

                <DialogContent dividers>
                    {!selectedFile ? (
                        <>
                            <div className="float-right" >
                                <Button variant="outlined" color="secondary" onClick={() => setChangeYear(!changeYear)}>Import For a Different Year </Button>
                            </div>
                            <br />
                            <br />
                            {changeYear &&
                                <div className='flex mt-2 mb-2'>
                                    <CustomTextField size="small" id="outlined-basic" placeholder="Filter By Year..." value={changedYear} onChange={(e) => setChangedYear(Number(e.target.value))} variant="outlined" sx={{ width: '70%' }} />&nbsp;&nbsp;
                                    <Button color='info' variant="contained" onClick={() => setYear(changedYear)} style={{ textTransform: 'none', fontSize: 12 }}> Change Year</Button>

                                </div>
                            }

                            <p style={{ fontSize: 13, marginBottom: 6 }}>
                                Please select an Excel file to import GTB records for the year <b>{year}</b>.
                            </p>

                            {/* ✅ Expected file name format */}
                            <p
                                style={{
                                    fontSize: 12,
                                    background: "#f5f5f5",
                                    border: "1px dashed #ccc",
                                    padding: "6px 10px",
                                    borderRadius: 6,
                                    marginBottom: 12,
                                    color: "#555",
                                }}
                            >
                                <b>Expected file name:</b> <br />
                                <code>GTB_PPT_{year}_Unmapped.xlsx</code>
                            </p>

                            <Button
                                variant="contained"
                                component="label"
                                color="success"
                                fullWidth
                                sx={{ mt: 1 }}
                            >
                                Choose Excel File (.xlsx)
                                <input
                                    hidden
                                    type="file"
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    onChange={(e) => {
                                        if (e.target.files && e.target.files.length > 0) {
                                            const file = e.target.files[0];
                                            const fileName = file.name;

                                            // ✅ Validate filename pattern
                                            const match = fileName.match(/GTB_PPT_(\d{4})_Unmapped\.xlsx$/i);
                                            if (!match) {
                                                showAlertMessage("⚠️ Invalid file name format. Expected: GTB_PPT_YYYY_Unmapped.xlsx");
                                                e.target.value = "";
                                                return;
                                            }

                                            // ✅ Check year consistency
                                            const fileYear = Number(match[1]);
                                            if (fileYear !== year) {
                                                showAlertMessage(`⚠️ The file year (${fileYear}) does not match the selected year (${year}).`);
                                                e.target.value = "";
                                                return;
                                            }

                                            setSelectedFile(file);
                                        }
                                    }}
                                />
                            </Button>
                        </>
                    ) : (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                border: "1px solid #ddd",
                                borderRadius: 6,
                                padding: "8px 12px",
                                backgroundColor: "#fafafa",
                            }}
                        >
                            <span style={{ fontSize: 13 }}>{selectedFile.name}</span>
                            <Button
                                color="error"
                                size="small"
                                variant="outlined"
                                onClick={() => setSelectedFile(null)}
                            >
                                Remove
                            </Button>
                        </div>
                    )}
                </DialogContent>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px 20px",
                        gap: 8,
                    }}
                >
                    <Button
                        onClick={() => {
                            setImportDialogOpen(false);
                            setSelectedFile(null);
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="success"
                        disabled={!selectedFile || isUploading}
                        onClick={async () => {
                            if (!selectedFile) return;

                            const formData = new FormData();
                            formData.append("MappedFile", selectedFile);

                            try {
                                setIsUploading(true);
                                uploadGBTRecordsExcelFile(formData, year);

                                setImportDialogOpen(false);
                                setSelectedFile(null);
                            } catch (err) {
                                showAlertMessage("❌ Upload failed. Please try again.");
                            } finally {
                                setIsUploading(false);
                            }
                        }}
                    >
                        {isUploading ? "Uploading..." : "Send"}
                    </Button>
                </div>
            </Dialog>
        </>
    )
}
export default GtBalanceRecords;